export class VssOverviewDataResponse {
  patchable: number = 0;
  patched_percentage: number = 0;
  unpatchable: number = 0;
  unpatchable_percentage: number = 0;
  total_instances: number = 0;
  unique_cves: number = 0;
  percent_consolidated: number = 0;
  last_fetch_datetime: string = '';
}

export class ProblemChildPatchesResponse {
  last_fetch_datetime: string = '';
  problemChildPatches: Array<{
    cve: string;
    assets: number;
    daysOld: number;
    severity: string;
  }> = [];
}

export class CriticalVulnerabilityAgingResponse {
  last_fetch_datetime: string = '';
  totalCriticalVulnerabilities: number = 0;
  ageRanges: Array<{
    range: string;
    count: number;
    percentage: number;
    patchable: number;
    color: string;
  }> = [];
}

export class AverageCoverageResponse {
  current_average_coverage: number | null = null;
  previous_average_coverage: number | null = null;
  percentage_difference: number | null = null;
}

export class AverageComplianceResponse {
  current_compliance_rate: number | null = null;
  previous_compliance_rate: number | null = null;
  percentage_difference: number | null = null;
}

export class AverageMeanTimeToMitigateResponse {
  current_average_mean_time_to_mitigate: number | null = null;
  previous_average_mean_time_to_mitigate: number | null = null;
  mttm_days_difference: number | null = null;
}

export class VulnerabilityEventsResponse {
  events: Array<{
    date: string;
    detected: number;
    mitigated: number;
  }> = [];
  patchingStats: {
    patchedPercentage: number;
  } = { patchedPercentage: 0 };
}

export class DeviceTypeChartResponse {
  data: Array<{
    device_type: string;
    device_count: number;
    vulnerability_count: number;
  }> = [];
}

export class MttmAnalysisResponse {
  mttm_trend: Array<{
    date: string;
    critical: number;
    high: number;
  }> = [];
  current_critical_average_mttm: number | null = null;
  previous_critical_average_mttm: number | null = null;
  critical_average_mttm_difference: number | null = null;
  current_high_average_mttm: number | null = null;
  previous_high_average_mttm: number | null = null;
  high_average_mttm_difference: number | null = null;
}

export class SLATargetsResponse {
    id: number | null = null;
    critical: number | null = null;
    high: number | null = null;
    organization: number | null = null;
}
